import { render, staticRenderFns } from "./user_shop_list.vue?vue&type=template&id=1964aec5"
import script from "./user_shop_list.vue?vue&type=script&lang=js"
export * from "./user_shop_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports